import { Route, Routes } from "react-router-dom";
import BtmHeader from "./Header/BtmHeader";
import TopHeader from "./Header/TopHeader";
import Home from "./Page/Home/Home";
import ProductDetails from "./Page/ProductDetails";
import Cart from "./Page/cart/Cart";
import { Toaster } from "react-hot-toast";
import Scroltotop from "./Componinets/Scroltotop";
import { AnimatePresence } from "framer-motion";
import Categorypage from "./Page/Categortpage/Categorypage";
import SerashResults from "./Page/SerashResults";
import Favorites from "./Page/favorites/Favorites";


function App() {
  return (
 <>
 <header>
  <TopHeader/>
  <BtmHeader/>
 </header>
<Toaster position="bottom-right" toastOptions={{
  style:{
    background:'#e9e9e9',
    borderRadius:'5px',
    padding:'14px'
  }
}}/>
<Scroltotop/>
<AnimatePresence mode="wait">
<Routes>
  <Route path="/" element={<Home/>}/>
  <Route path="/Cart" element={<Cart/>}/>
  <Route path="/serash" element={<SerashResults/>}/>
   <Route path="/Favorites" element={<Favorites/>}/>
  <Route path="/products/:id" element={<ProductDetails/>}/>
    <Route path="/category/:category" element={<Categorypage/>}/>


</Routes>
 </AnimatePresence>
 </>
  );
}

export default App;
